<template>
	<dialog-slot
			:title="dialogTitle"
			@updateClose="onDrawerClose"
			@updateSave="onSave"
			:is-btn-safe="isFrozen"
			width="450px"
	>
		<template slot="subTitle">
			<div class="baseGray body-2">{{ date }}</div>
		</template>
		<template slot="topButtons">
			<exception-b-t-n v-if="!activeItem"
					@updateException="onException"
			/>
		</template>

		<div class="CustomerPopupWrap">
			<div class="baseOrange">Be mindful when selecting a customer name</div>
			<field
					:classError="$v.customer.$error || isFrozen"
					margin="0"
					label="Customer"
					placeholder="Select customer name"
					@updateAutocomplete="onAutocomplete($event, 'customer')"
					:autocompleteValue="customer"
					:items="customerList"
					:isClearable="false"
					is-required
					is-autocomplete
					item-text="name"
					item-value="division_id"
			></field>

			<div v-if="isFrozen" class="frozenMessage"> ⚠️ This customer is frozen. Creating actions is temporarily disabled.</div>

		<field
					:classError="$v.driver_id.$error"
					margin="0"
					label="Driver"
					placeholder="Select driver name"
					@updateAutocomplete="onAutocomplete($event, 'driver')"
					:autocompleteValue="driver"
					:items="driverList"
					:isClearable="false"
					is-required
					is-autocomplete
					item-text="driver"
					item-value="driver_id"
					:is-disabled="getDriverList || isFrozen"
			></field>

			<field
					:classError="$v.date.$error"
					margin="0"
					type="text"
					label="Chicago date"
					placeholder="Enter date"
					:dateValue="date"
					@updateDate="onDate($event)"
					is-date
					is-required
					:is-disabled="isFrozen"
			></field>

			<field
					:classError="$v.time.$error"
					margin="0"
					label="Chicago time"
					placeholder="HH:MM"
					:setInputValue="time"
					@updateInput="onInput($event, 'time')"
					is-required
					is-input
					is-time-field
					:is-disabled="isFrozen"
			/>

			<field
					:classError="$v.note.$error"
					margin="0"
					label="Note"
					placeholder="Enter note"
					@updateInput="onInput($event, 'note')"
					:setInputValue="note"
					is-required
					isTextarea
					:is-disabled="isFrozen"
			></field>

<!--			<field-->
<!--					:classError="$v.file.value.$error"-->
<!--					margin="0"-->
<!--					label="Screen"-->
<!--					placeholder="add file"-->
<!--					:setInputValue="file.name"-->
<!--					@updateFile="onFile($event)"-->
<!--					is-file-->
<!--					is-readonly-->
<!--					is-required-->
<!--			></field>-->

<!--			<field-->
<!--					margin="0"-->
<!--					label="Screen"-->
<!--					placeholder="add file"-->
<!--					:setInputValue="file.name"-->
<!--					@updateFile="onFile($event)"-->
<!--					is-file-->
<!--					is-readonly-->
<!--			></field>-->
<!--			:classError="$v.file.value.$error"-->

			<paste-image-field
					:classError="$v.file.value.$error"
					v-model="screenshot"
					:required="true"
					:max-size="5 * 1024 * 1024"
					:accept="['image/png','image/jpeg','image/webp']"
					@meta="onUpdatePasteImageField"
					:screenshotEdit="screenshotEdit"
			/>

<!--			<div :class="['labelClone', {'text-error': $v.request_id.$error}]" >-->
<!--				Request from-->
<!--			</div>-->

<!--			<v-radio-group-->
<!--					v-model="request_id"-->
<!--					dense-->
<!--					row-->
<!--					:error-messages="$v.request_id.$error ? ['Please select request type'] : []"-->
<!--					class="no-margin"-->
<!--			>-->
<!--				<v-radio-->
<!--						v-for="item in requestList"-->
<!--						:key="item.id"-->
<!--						class="request"-->
<!--						:label="item.name"-->
<!--						:value="item.id"-->
<!--				/>-->
<!--			</v-radio-group>-->

			<radio-field
					v-model="request_id"
					:items="requestList"
					label="Request from"
					:validation="$v.request_id"
					error-text="Please select request type"
			></radio-field>
		</div>

		<preload v-if="isPreload"></preload>

	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import getChicagoDate from "@/helper/getChicagoDate";
import ExceptionBTN from "@/pages/Safety/LogbooksList/ExceptionBTN/ExceptionBTN.vue";
import getChicagoTime from "@/helper/getChicagoTime";
// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
import parseDateTime from "@/helper/parseDateTime";
import PasteImageField from "@/components/PasteImageField/PasteImageField.vue";
import RadioField from "@/shared/RadioField/RadioField.vue";
export default {
	name: "CreateActions",
	mixins: [ validationMixin ],
	components: {
		RadioField,
		PasteImageField,
		Preload,
		ExceptionBTN,
		DialogSlot
	},
	computed: {
		getDriverList() {
			return this.driverList.length === 0;
		},
		isFrozen() {
			return this.frozen === 1 || this.frozen === true;
		}
	},
	props: {
		activeItem: {
			type: Object,
			default: null
		},
		activeLine: Object,
		customerList: Array,
		requestList: Array,
		exceptionCount: Number,

	},
	data: () => ({
		dialogTitle: null,
		chicagoDate: null,
		isChangeCompanyDrawer: false,
		driverList: [],
		customer: null,
		frozen: null,
		driver: null,
		driver_id: null,
		date: null,
		time: null,
		note: null,
		file: {
			name: "",
			value: ""
		},
		isPreload: false,
		id: null,
		request_id: null,
		screenshot: null,
		screenshotEdit: null,
	}),

	validations: {
		customer: { required },
		driver_id: { required },
		date: { required },
		time: { required },
		note: { required },
		request_id: { required },
		file: {
			value: { required }
		}
	},

	methods: {
		...mapActions([
			'getSafetyCreateAction',
		]),

		onUpdatePasteImageField(el) {
			const { dataUrl, name } = el;
			this.file.name = name;
			this.file.value = dataUrl;
		},
		onException() {
			this.$emit("updateCloseDialogCreateActions");
			this.$emit("updateException");
		},

		onDrawerClose(type) {
			if ( type == "close" || type == "outside" ) this.onClose();
			if ( type == "cancel" ) this.onCancel();
		},
		onClose() {
			this.$emit("updateCloseDialogCreateActions");
		},
		onCancel() {
			this.$emit("updateCloseDialogCreateActions");
		},
		onAutocomplete({ value }, key) {
			if (key === 'customer') {
				this.driverList = value.drivers;
				//  знімаємо валідацію при переході в frozen і нормалізуємо значення
				this.frozen = value.frozen;
				if (this.isFrozen) {
					this.$v.$reset(); //  скинути "почіркнення" помилок
				}
			}
			if (key === 'driver') this.driver_id = value.driver_id;
			this[key] = value;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		// onFile(e) {
		// 	const iFile = e.target.files[0];
		// 	const reader = new FileReader();
		//
		// 	reader.readAsDataURL(iFile);
		// 	reader.onload = () => {
		// 		this.file = {
		// 			name: iFile.name,
		// 			value: reader.result
		// 		};
		// 	};
		// },
		async onSave() {
			this.$v.$touch(); // активирует валидацию всех полей

			if (this.$v.$invalid) return; // если есть ошибка — выходим

			const { driver_id, date, time, note, id, request_id, file } = this.$data;

			let values = { driver_id, date, time, note, request_id, file: file.value, file_name: file.name };

			if ( id ) values = { id, driver_id, date, time, note, request_id, file: file.value, file_name: file.name };

			await this.getSafetyCreateAction( values );
			this.$emit("updateList", !!this.activeItem);
			this.onClose();
		},
		onDate(date) {
			this.date = date;
		},
	},
	mounted() {
		this.dialogTitle = 'Create action';
		this.date = getChicagoDate();
		this.time = getChicagoTime();

		if (this.activeItem) {
			this.dialogTitle = 'Edit action';
			const { dateTime, driver_id, notes, file, file_name, id, request_id } = this.activeItem;
			const { customer_id } = this.activeLine;

			this.isPreload = true;
			this.id = id;

			this.customer = this.customerList.find(item =>
				item.division_id === customer_id
			);
			const { drivers, frozen } = this.customer;
			this.frozen = frozen;
			this.driverList = drivers;
			this.driver = drivers.find(item =>
				item.driver_id === driver_id
			);
			this.driver_id = this.driver.driver_id;

			const dateTimeParse = parseDateTime(dateTime);

			this.date = dateTimeParse.date;
			this.time = dateTimeParse.timeWithoutSeconds;

			this.request_id = request_id;
			this.note = notes;
			this.file.value = file;
			this.file.name = file_name;

			this.screenshotEdit = { name: file_name, url: file };
			
			this.isPreload = false;

		}
	}
};
</script>

<style scoped lang="scss">
.CustomerPopupWrap {
	display: flex;
	flex-direction: column;
	gap: 10px;
}
.frozenMessage {
	color: var(--base-red);
	font-size: 14px;
}

</style>
